import type { Reimbursement } from "@/types";

/** Display labels for the authoritative `payment_method` values (check/ach/eft/wire). */
export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  check: "Check",
  ach: "ACH",
  eft: "EFT",
  wire: "Wire",
};

/**
 * Payment type for a reimbursement (#5310 export tab + #5359 in-app table). Prefers the
 * authoritative `payment_method` (check/ach/eft/wire); falls back to the legacy
 * `eft`/`check_number` fields for rows that predate it. Returns "—" when nothing is set.
 */
export const paymentTypeLabel = (r: Reimbursement): string => {
  if (r.payment_method) return PAYMENT_METHOD_LABELS[r.payment_method] ?? r.payment_method.toUpperCase();
  if (r.eft) return "EFT";
  if (r.check_number) return "Check";
  return "—";
};
